import React from 'react'
import { Link } from "react-router-dom"
import { Result } from 'antd'
import language from "../resources/languages/fa_IR"

const { Pages: { NotFound: NotFoundLanguage }, Share } = language

export default function NotFound() {

    return <Result
        status="404"
        title="404"
        subTitle={NotFoundLanguage.description}
        extra={<Link to="/">{Share.backDashboard}</Link>}
    />
}
